import React, { useState, useRef } from 'react';
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory, { PaginationProvider, PaginationListStandalone } from "react-bootstrap-table2-paginator";
import { MessageEmtyData } from "@ui-partents/Message";
import { useDispatch, useSelector } from "react-redux";
import { shareMedia } from "@actions";
import styled from 'styled-components';

//apiCaller
import { apiCaller } from "@utils";

//constants
import { teachV2Constants } from "@constants";

//Icon
import { Icon } from '@components/common';
import More from '@images/teachV2/more-vertical.svg';

//elements
import { WrapModalDeleteCommon } from "@ui-partents/Modal";

//utils
import { LoaderText } from "@utils";

//components
import { UploadFileSuggestion, UploadButton } from "../ReferenceLiblary";
import { WrapModalUploadMedia, ModalUploadReferenceMedia, WrapModalEdit } from "./ModalMedia";
import { listTypeUploadMedia } from '@utils/dataDefault'

//moment
import moment from "moment";

//components
// import { StatusType } from './ModalMedia';
import ReactTooltip from 'react-tooltip';
import { toast } from 'react-toastify';
import CreatableSelect from 'react-select/creatable';
import Select, { components } from 'react-select';
import ModalWatchMedia from './ModalMedia/ModalWatchMedia';

// Import the pagination configuration
import {paginationOptions} from "@utils";

const ReferenceMediaWrap = (props) => {
  const { loadDataReferenceBook, listValue, setListValue, inputValue, setInputValue, setListType, listType } = props;
  const { SearchBar } = Search;
  const dispatch = useDispatch();
  const { dataFilter: documents, isLoading } = useSelector((state) => state.getReferenceMedia) || {};
  const [dataView, setDataView] = useState(null)
  const [modal, setModal] = useState({
    uploadDocument: false,
    modalView: false
  });
  const isSearchingOrPaging = useRef(false);

  const handleShareReference = async (data) => {
    const dataShare = await dispatch(shareMedia({
      "Action": "ShareToInstitution",
      "MediaItemId": data?.id
    }))
    if (dataShare?.data?.status === 200) {
      toast.success('Successfully shared to Organization Media', {
        position: "bottom-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      loadDataReferenceBook()
      setListValue([])
      setListType([])
    }
  }

  const handleUnshareReference = async (data) => {
    const dataShare = await dispatch(shareMedia({
      "Action": "UnShareToInstitution",
      "MediaItemId": data?.id
    }))
    if (dataShare?.data?.status === 200) {
      toast.success('Successfully unshared from Organization Media', {
        position: "bottom-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      loadDataReferenceBook()
      setListValue([])
      setListType([])
    }
  }

  //toggle
  const toggle = (type, value = null) => {
    setModal((prevState) => ({ ...prevState, [type]: !prevState[type] }));
  };

  // Handle Remove Document
  const handleRemoveMedia = (id) => {
    if (id) {
      const params = {
        "Action": "Delete",
        "MediaItemId": id
      };
  
      const isLoading = true;
      dispatch({ type: teachV2Constants.DELETE_REFERNECE_MEDIA_REQUEST, isLoading });
  
      apiCaller(`/api/media/library/`, 'POST', params)
        .then(res => {
          if (res?.data) {
            dispatch({ type: teachV2Constants.DELETE_REFERNECE_MEDIA_SUCCESS, payload: res.data });
            loadDataReferenceBook()
            setListValue([])
            setListType([])
          } else {
            const error = "error";
            dispatch({ type: teachV2Constants.DELETE_REFERNECE_MEDIA_FAILURE, error });
          }
        })
        .catch(err => {
          const errorMessage = err.message || "API call failed";
          dispatch({ type: teachV2Constants.DELETE_REFERNECE_MEDIA_FAILURE, error: errorMessage });
        })
        .finally(() => {
        });
    }
  };

  const componentsCommon = {
    DropdownIndicator: () => null,
    IndicatorSeparator: () => null,
    MultiValueContainer: (props) => {
      return (
        <div className="custom-tag">
          <components.MultiValueContainer {...props} />
        </div>
      );
    }
  };

  const handleAddTag = (value) => {
    setListValue(value)
  }

  const createOption = (label) => ({
    label,
    value: label,
  });

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        setListValue((prev) => prev ? [...prev, createOption(inputValue)] : [createOption(inputValue)]);
        setInputValue('');
        event.preventDefault();
        break;
      default:
        break;
    }
  };

  const handleOpenUrl = (row) => {
    if (row.type === 'URL') {
      window.open(`${row?.url}`, "_blank")
    } else {
      toggle('modalView')
      setDataView(row)
    }
  }

  const columns = [
    {
      dataField: "title",
      text: "Media Name",
      headerClasses: "text-nowrap",
      headerStyle: { width: "200px" },
      formatter: (cell, row) => {
        return (
          <React.Fragment>
            <div 
              className='text-w-600' 
              onClick={() => {
                if (row.url.includes("med2lab-frontend-media.s3.amazonaws.com")) {
                  handleOpenUrl(row)
                } else {
                  window.open(`${row?.url}`, "_blank")
                }
              }}
              style={{ cursor: "pointer" }}  
            >
              {row?.title}
            </div>
          </React.Fragment>
        );
      },
    },
    {
      dataField: "descriptions",
      text: "Description",
      headerClasses: "text-nowrap",
    },
    {
      dataField: "type",
      text: "View Media",
      headerClasses: "text-nowrap",
      headerStyle: { width: "200px" },
      formatter: (cell, row) => {
        return (
          <TextLink>
            {cell &&
              <span 
                className='text-link'
                style={{wordBreak: 'break-all'}}
                onClick={() => {
                  if (row.url.includes("med2lab-frontend-media.s3.amazonaws.com")) {
                    handleOpenUrl(row)
                  } else {
                    window.open(`${row?.url}`, "_blank")
                  }
                }}
              >
                {cell}
              </span>
            }
          </TextLink>
        );
      },
    },
    
    {
      Field: "tags",
      text: "Tags",
      headerClasses: "align-middle text-center",
      headerStyle: { width: "200px" },
      formatter: (cell, row) => {
        return (
          <div className="d-flex align-items-center justify-content-center">
            {row?.tags?.length > 0 ? (
              <>
                <div className="tag-library">
                  {row?.tags?.[0]}
                </div>
                {row?.tags?.length > 1 && (
                  <div className="tag-library ml-1" data-tip data-for={`tag-${row?.document_id}`}>
                    +{row?.tags?.length - 1}
                    <ReactTooltip id={`tag-${row?.document_id}`} place='top' effect='solid' className="tooltip-tags">
                      <div className='list-tags'>
                        {row?.tags?.map((tag, index) => (
                          index > 0 && tag && <span>{tag}</span>
                        ))}
                      </div>
                    </ReactTooltip>
                  </div>
                )}
              </>
            ) : (<></>)}
          </div>
        );
      },
    },
    {
      dataField: "created_at",
      text: "Date Created",
      headerClasses: "text-nowrap",
      headerStyle: { width: "200px" },
      formatter: (cell, row) => {
        return (
          <div className='format-time'>{moment(cell).format('DD/MM/YYYY hh:mm A')}</div>
        );
      },
    },
    {
      dataField: "",
      text: "Action",
      headerClasses: "text-center",
      headerStyle: { width: "50px" },
      formatter: (cell, row) => {
        return (
          <div className="d-flex align-items-center justify-content-center action-reference">
            <Icon src={More}/>
            <div className="action-reference__list">
              {!row?.shared_to_institution ? (
                <p onClick={() => handleShareReference(row)}>Share to Organization</p>
              ) : (
                <p onClick={() => handleUnshareReference(row)}>Unshare</p>
              )}
              <WrapModalEdit
                title="Edit Media"
                currentItem={row}
                createOption={createOption}
                setListValueFilter={setListValue}
                setListType={setListType}
                {...props}
              >
                {({onOpen}) => (
                  <p onClick={onOpen}>Edit</p>
                )}
              </WrapModalEdit>
              <WrapModalDeleteCommon
                title={`Delete Media`}
                sub={`Are you sure you want to delete this Media? This action cannot be undone.`}
                handleRemove={handleRemoveMedia}
                idRemove={row?.id}
              >
                {({onOpen}) => (
                  <p onClick={onOpen}>Delete</p>
                )}
              </WrapModalDeleteCommon>
            </div>
          </div>
        );
      },
    }
  ];

  const handleBlur = () => {
    if (inputValue) {
      setListValue((prev) => prev ? [...prev, createOption(inputValue)] : [createOption(inputValue)]);
    }
  }

  const contentTable = ({ paginationProps, paginationTableProps }) => (
    <ToolkitProvider keyField="id" data={documents?.MyMedia || []} columns={columns} search>
      {(toolkitprops) => (
        <div>
          <div className="d-flex align-items-center justify-content-between">
            <div className='tb-heading-total'>Total File: {documents?.MyMedia?.length}</div>
            <div className='d-flex align-items-center'>
              <div className="boxSearch">
                <SearchBar
                  {...toolkitprops.searchProps}
                  onSearch={(e) => {
                    paginationProps.page = 1;
                    toolkitprops.searchProps.onSearch(e);
                    isSearchingOrPaging.current = false;
                  }}
                  onKeyUp={() => { isSearchingOrPaging.current = true; }}
                />
              </div>
              <div className="email-share__form-input ml-2">
                <CreatableSelect
                  components={componentsCommon}
                  inputValue={inputValue}
                  isClearable
                  isMulti
                  menuIsOpen={false}
                  onChange={(newValue) => {
                    handleAddTag(newValue)}
                  }
                  onInputChange={(newValue) => {
                    setInputValue(newValue)
                  }}
                  onKeyDown={(e) => {
                    paginationProps.onPageChange(1, 10);
                    handleKeyDown(e)
                  }}
                  onBlur={handleBlur}
                  placeholder="Filter by Tags"
                  value={listValue}
                  classNamePrefix={`filter-tag`}
                />
              </div>
              <div className="email-share__form-input ml-2">
                <Select
                  components={componentsCommon}
                  isMulti
                  placeholder="Filter by Type"
                  options={listTypeUploadMedia}
                  classNamePrefix="filter-tag"
                  onChange={(newValue) => {
                    paginationProps.onPageChange(1, 10);
                    setListType(newValue)
                  }}
                  value={listType}
                />
              </div>
              <WrapModalUploadMedia
                title="Upload Media"
                {...props}
              >
                {({onOpen}) => (
                  <UploadButton {...props} toggle={onOpen} textBtn="Upload Media" />
                )}
              </WrapModalUploadMedia>
            </div>
          </div>
          <BootstrapTable
            condensed
            wrapperClasses="table-custom-common table-responsive mt-4"
            bordered={false}
            data={documents?.MyMedia}
            columns={columns}
            noDataIndication={() => (
              <MessageEmtyData
                title="No Results Found"
                text="Sorry, we couldn't find any matches for your search. Please try adjusting your search terms or using different keywords."
              />
            )}
            {...paginationTableProps}
            {...toolkitprops.baseProps}
          />
          <div className="pagination-custom-case d-flex justify-content-end ml-4">
            <PaginationListStandalone {...paginationProps} />
          </div>
        </div>
      )}
    </ToolkitProvider>
  );

  // Dynamic determination of total size
  const totalSize = documents?.MyMedia?.length || 0;

  // Generate pagination configuration dynamically
  const paginationConfig = paginationOptions({ totalSize });
  return (
    <React.Fragment>
      <div className={`table-refer bg-white ${documents?.MyMedia?.length === 0 ? 'position-relative' : ''}`} style={{ height: documents?.MyMedia?.length === 0 ? 'calc(100vh - 72px)' : 'auto' }}>
        {isLoading ? (
          <LoaderText />
        ) : (
          (documents?.MyMedia?.length > 0 || listValue?.length > 0 || listType?.length > 0) &&
          <PaginationProvider pagination={paginationFactory(paginationConfig)}>
            {contentTable}
          </PaginationProvider>
        )}
        {documents?.MyMedia?.length === 0 && !isLoading && listValue?.length === 0 && listType?.length === 0 &&(
          <UploadFileSuggestion 
            title="Build Your Media Library"
            content="It looks like you haven't uploaded any media yet. Click the ‘Upload Media’ button to get started."
            org={false}
            toggle={toggle}
            textBtn="Upload Media"
            {...props} 
          />
        )}
      </div>
      <ModalUploadReferenceMedia
        isOpen={modal.uploadDocument}
        toggleModal={() => toggle("uploadDocument")}
        title="Upload Media"
        {...props} 
      />
      <ModalWatchMedia
        isOpen={modal.modalView}
        toggleModal={() => toggle("modalView")}
        dataView={dataView}
        {...props} 
      />
    </React.Fragment>
  );
};

const TextLink = styled.p`
  color: #1570EF;
  font-size: 14px;
  font-weight: 400;
  text-decoration-line: underline;
  .text-link {
    cursor: pointer;
  }
`

export default ReferenceMediaWrap;